import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: "nullCleaner", pure: false })
export class NullCleanerPipe implements PipeTransform {
  transform(array: string[]): string {
    return array.filter((item) => item).join(", ");
  }
}
